/* @flow */

import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { ampli } from 'src/ampli';
import { getAmplitudeKey } from 'src/shared/app/base/selector/appEnvSelectors';
import { setActiveFeatures } from 'src/shared/app/base/tracking/analytics';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import useSelf from 'src/shared/domain/user/hook/useSelf';

export default function useAmplitudeTracking() {
  const key = useSelector(getAmplitudeKey);
  const event = useEvent();

  if (key) {
    const user = useSelf();

    useEffect(() => {
      ampli.load({
        client: {
          apiKey: key,
          configuration: {
            defaultTracking: true,
            groups: {
              activation: event?.id,
            },
          },
        },
      });
    }, []);

    useEffect(() => {
      if (ampli.isLoaded && user?.id) {
        ampli.identify(user.uuid);
      }
    }, [user, ampli.isLoaded]);
    useEffect(() => {
      if (ampli.isLoaded && event.id) {
        ampli.client.setGroup('activation', event.id);
        setActiveFeatures(Object.keys(event.features));
      }
    }, [event, ampli.isLoaded]);
  }
}
